<router-outlet></router-outlet>
<app-connection-warning></app-connection-warning>
<app-http-error-toast-host></app-http-error-toast-host>
